export enum BeneficiaryTypeEnum {
  General = 1,
  Spousal = 2,
  Contingent = 3,
  Specified = 4
}
